export const createStrikeLevels = ({ itm = 5, otm = 5 }) => {
  const itms = [];
  const otms = [];

  for (let indexItm = 1; indexItm <= itm; indexItm++) {
    itms.push({
      label: `ITM ${indexItm}`,
      value: `ITM_${indexItm}`,
    });
  }

  for (let indexOtm = 1; indexOtm <= otm; indexOtm++) {
    otms.push({
      label: `OTM ${indexOtm}`,
      value: `OTM_${indexOtm}`,
    });
  }

  return [...itms.reverse(), { label: 'ATM', value: 'ATM' }, ...otms];
};
